import styled from 'styled-components';
import { ModalShareConfigurationBasketStyled } from '../ModalShareConfigurationBasketStyled';

export const ModalShareConfigurationBasketStyledAP = styled(ModalShareConfigurationBasketStyled)``;
